var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "tab-title" }, [
        _vm._v(_vm._s(_vm.selectNode.name)),
      ]),
      _vm.name && _vm.formConfig.length > 0
        ? _c(
            "el-tabs",
            {
              class: [
                _vm.selectNode.type === "CC" && !_vm.isProcess
                  ? "set-tabs set-tabs-3"
                  : "set-tabs",
              ],
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.name, name: "properties" } },
                [
                  _c((_vm.selectNode.type || "").toLowerCase(), {
                    tag: "component",
                    attrs: {
                      config: _vm.selectNode.props,
                      isProcess: _vm.isProcess,
                      setType: "base",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "表单操作权限", name: "permissions" } },
                [
                  _c("form-authority-config", {
                    attrs: { isProcess: _vm.isProcess },
                  }),
                ],
                1
              ),
              _vm.selectNode.type === "CC" && !_vm.isProcess
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "高级设置", name: "advancedSetting" } },
                    [
                      _c((_vm.selectNode.type || "").toLowerCase(), {
                        tag: "component",
                        attrs: { config: _vm.selectNode.props, setType: "pro" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c((_vm.selectNode.type || "").toLowerCase(), {
            tag: "component",
            attrs: { config: _vm.selectNode.props },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }